import { Component } from '@angular/core';
import { AuthService } from '../core/auth.service';

@Component({
  selector: 'app-header',
  template: `
    <nav class="navbar navbar-expand-lg navbar-light py-1 px-2 nav-border">
      <a class="navbar-brand p-0" [routerLink]="['/recurrence/tour']">
        <img class="d-inline-block align-top mr-2 header-company-logo" src="assets/img/PDI-logo.png" alt="PDI Technologies" />
        <div class="d-inline-block">
          <span class="navbar-text title p-0">Easy Planning</span>
          <span class="navbar-text sub-title p-0">Recurring Tours</span>
        </div>
      </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ml-auto">
        </ul>
      </div>
    </nav>
  `,
  styles: [`
    :host {
      display: block;
      -ms-flex: 0 1 auto;
      flex: 0 1 auto;
      background: linear-gradient(to bottom, rgba(203,203,203,1) 0%, rgba(0,0,0,0) 100%);
    }
    .title {
      color: #3b3b3b;
      font-size: 1rem;
      font-weight: bold;
      text-shadow: 1px 2px 8px #636363;
      float: left;
    }
    .sub-title {
      color: #3b3b3b;
      font-size: 0.8125rem;
      font-weight: bold;
      text-shadow: 1px 2px 8px #636363;
      float: left;
      clear: left;
    }
    .nav-border {
      border-bottom: 1px solid #bfbfbf;
    }
    .header-company-logo {
      padding: 5px 5px;
      height: 50px;
      float: left;
    }
  `]
})
export class HeaderComponent {

  constructor(
    public authService: AuthService
  ) {}

}



// WEBPACK FOOTER //
// ./src/app/layout/header.component.ts